import { atom } from "recoil";

// KPC 스캔 원장 API의 서버 페이지 정보를 운송장관리 화면에서 공유한다.
export const kpcScanPaginationState = atom({
  key: "kpcScanPaginationState",
  default: {
    totalCount: 0,
    page: 0,
    size: 50,
  },
});
